enum SearchActions {
    Request = 'search/REQUEST',
    Result = 'search/RESULT',
    Error = 'search/ERROR'
}

export const SearchActionTypes = {
    ...SearchActions
};
